"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var react_1 = (0, tslib_1.__importStar)(require("react"));

var helpers_1 = require("../helpers");

var DropzoneDialogBase_1 = (0, tslib_1.__importDefault)(require("./DropzoneDialogBase"));
/**
 * This component provides an uncontrolled version of the DropzoneDialogBase component.
 *
 * It supports all the Props and Methods from `DropzoneDialogBase` but keeps the files state internally.
 *
 * **Note** The `onSave` handler also returns `File[]` with all the accepted files.
 */

var DropzoneDialog = /*#__PURE__*/function (_react_1$PureComponen) {
  _inherits(DropzoneDialog, _react_1$PureComponen);

  var _super = _createSuper(DropzoneDialog);

  function DropzoneDialog() {
    var _this;

    _classCallCheck(this, DropzoneDialog);

    _this = _super.apply(this, arguments);
    _this.state = {
      fileObjects: []
    };

    _this.notifyFileChange = function () {
      var onChange = _this.props.onChange;
      var fileObjects = _this.state.fileObjects;

      if (onChange) {
        onChange(fileObjects.map(function (fileObject) {
          return fileObject.file;
        }));
      }
    };

    _this.loadInitialFiles = function () {
      return (0, tslib_1.__awaiter)(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var _this$props$initialFi, initialFiles, fileObjs;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props$initialFi = this.props.initialFiles, initialFiles = _this$props$initialFi === void 0 ? DropzoneDialog.defaultProps.initialFiles : _this$props$initialFi;
                _context2.prev = 1;
                _context2.next = 4;
                return Promise.all(initialFiles.map(function (initialFile) {
                  return (0, tslib_1.__awaiter)(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var file, data, fileObj;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(typeof initialFile === "string")) {
                              _context.next = 6;
                              break;
                            }

                            _context.next = 3;
                            return (0, helpers_1.createFileFromUrl)(initialFile);

                          case 3:
                            file = _context.sent;
                            _context.next = 7;
                            break;

                          case 6:
                            file = initialFile;

                          case 7:
                            _context.next = 9;
                            return (0, helpers_1.readFile)(file);

                          case 9:
                            data = _context.sent;
                            fileObj = {
                              file: file,
                              data: data
                            };
                            return _context.abrupt("return", fileObj);

                          case 12:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                }));

              case 4:
                fileObjs = _context2.sent;
                this.setState(function (state) {
                  return {
                    fileObjects: [].concat(_toConsumableArray(state.fileObjects), _toConsumableArray(fileObjs))
                  };
                }, this.notifyFileChange);
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                // eslint-disable-next-line no-console
                console.log(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));
    };

    _this.addFiles = function (newFileObjects) {
      return (0, tslib_1.__awaiter)(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$props$filesLimi, filesLimit;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props$filesLimi = this.props.filesLimit, filesLimit = _this$props$filesLimi === void 0 ? DropzoneDialog.defaultProps.filesLimit : _this$props$filesLimi; // Update component state

                this.setState(function (state) {
                  // Handle a single file
                  if (filesLimit <= 1) {
                    return {
                      fileObjects: [newFileObjects[0]]
                    };
                  } // Handle multiple files


                  return {
                    fileObjects: [].concat(_toConsumableArray(state.fileObjects), _toConsumableArray(newFileObjects))
                  };
                }, this.notifyFileChange);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };

    _this.deleteFile = function (removedFileObj, removedFileObjIdx) {
      event === null || event === void 0 ? void 0 : event.stopPropagation();
      var onDelete = _this.props.onDelete;
      var fileObjects = _this.state.fileObjects; // Calculate remaining fileObjects array

      var remainingFileObjs = fileObjects.filter(function (fileObject, i) {
        return i !== removedFileObjIdx;
      }); // Notify removed file

      if (onDelete) {
        onDelete(removedFileObj.file);
      } // Update local state


      _this.setState({
        fileObjects: remainingFileObjs
      }, _this.notifyFileChange);
    };

    _this.handleClose = function (evt, reason) {
      var _this$props = _this.props,
          clearOnUnmount = _this$props.clearOnUnmount,
          onClose = _this$props.onClose;

      if (onClose) {
        onClose(evt, reason);
      }

      if (clearOnUnmount) {
        _this.setState({
          fileObjects: []
        }, _this.notifyFileChange);
      }
    };

    _this.handleSave = function (evt) {
      var _this$props2 = _this.props,
          clearOnUnmount = _this$props2.clearOnUnmount,
          onSave = _this$props2.onSave;
      var fileObjects = _this.state.fileObjects;

      if (onSave) {
        onSave(fileObjects.map(function (fileObject) {
          return fileObject.file;
        }), evt);
      }

      if (clearOnUnmount) {
        _this.setState({
          fileObjects: []
        }, _this.notifyFileChange);
      }
    };

    return _this;
  }

  _createClass(DropzoneDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadInitialFiles();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var clearOnUnmount = this.props.clearOnUnmount;

      if (clearOnUnmount) {
        this.setState({
          fileObjects: []
        }, this.notifyFileChange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var fileObjects = this.state.fileObjects;
      return react_1.default.createElement(DropzoneDialogBase_1.default, Object.assign({}, this.props, {
        fileObjects: fileObjects,
        onAdd: this.addFiles,
        onDelete: this.deleteFile,
        onClose: this.handleClose,
        onSave: this.handleSave
      }));
    }
  }]);

  return DropzoneDialog;
}(react_1.PureComponent);

DropzoneDialog.propTypes = Object.assign(Object.assign({}, DropzoneDialogBase_1.default.propTypes), {
  clearOnUnmount: prop_types_1.default.bool,
  filesLimit: prop_types_1.default.number,
  initialFiles: prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.any])),
  onSave: prop_types_1.default.func
});
DropzoneDialog.defaultProps = {
  clearOnUnmount: true,
  filesLimit: 3,
  initialFiles: []
};
exports.default = DropzoneDialog;